<template>
  <div class="modal">
    <Loading v-if="pageLoading" />
    <div class="modal-content">
      <div class="top-photo-and-content">
        <h2>{{ orderDetails.restaurantName }}</h2>
        <div class="content">
          <div class="left">
            <p>
              <b>Restaurant Location: </b>{{ orderDetails.restaurantLocation }}
            </p>
            <br />
            <p><b>Date: </b>{{ dateToDisplay() }}</p>
            <br />
            <p><b>Delivered To: </b>{{ orderDetails.deliveryLocation }}</p>
            <br />
            <p><b>Total Price: </b>S${{ orderDetails.totalPrice }}</p>
            <br />
          </div>
          <div class="right">
            <p><b>Saviour Name: </b>{{ orderDetails.saviourName }}</p>
            <br />
            <p><b>Saviour Contact: </b> {{ orderDetails.saviourContact }}</p>
          </div>
        </div>
        <div class="items">
          <OrderSummaryItemView
            :key="index"
            v-for="index in arrayIndexes"
            :itemName="orderDetails.cart[index]"
            :itemValue="orderDetails.cart[index + 1]"
            :itemQuantity="orderDetails.cart[index + 2]"
          />
        </div>
      </div>
      <div class="bottom">
        <button @click.prevent="closeModal">Close</button>
        <button class="repeat-btn" @click.prevent="repeatOrder">
          Let's Repeat
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import OrderSummaryItemView from "../components/OrderSummaryItemView.vue";
import Loading from "../components/Loading.vue";

export default {
  name: "OrderDetailsOnDashboard",
  props: ["orderDetails"],
  components: {
    OrderSummaryItemView,
    Loading,
  },
  data() {
    return {
      arrayIndexes: [],
      pageLoading: false,
      monthsOfTheYear: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  created() {
    for (let i = 1; i < this.orderDetails.cart.length; i += 3) {
      this.arrayIndexes.push(i);
    }
  },
  methods: {
    async repeatOrder() {
      this.pageLoading = true;
      this.$store.state.profileCart = this.orderDetails.cart;
      await this.$store.dispatch("updateCart");
      this.pageLoading = false;
      this.$router.push({ name: "Cart" });
    },
    closeModal() {
      this.$emit("close-order-details-dashboard");
    },
    dateToDisplay() {
      const date = new Date(this.orderDetails.orderTime.toDate());
      return (
        date.getDate() +
        " " +
        this.monthsOfTheYear[date.getMonth()] +
        " " +
        date.getFullYear()
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  // Changed from 101 to 102 due to overlapping issue in OrderSummary
  z-index: 102;
  //position: absolute;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.7);

  .modal-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 8px;
    margin: 10px;
    //width: 75vw;

    background-color: #fff;
    color: #fff;

    .top-photo-and-content {
      overflow: auto;
      flex-basis: 90%;
      border-radius: 8px;
      height: 28vh;
      //background-color: #837960;
      background-image: linear-gradient(to bottom, transparent, #f1f1f1),
        url("../assets/background/background10.jpeg");
      background-repeat: no-repeat;
      background-size: cover;
      //10,16,17,18,20,21
      display: flex;
      flex-direction: column;
      color: #fff;

      h2 {
        text-align: center;
        padding: 15px 0;
      }

      .content {
        flex-basis: 30%;
        padding: 10px 30px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        text-align: left;

        @media (min-width: 800px) {
          flex-direction: row;
          text-align: center;
        }

        .left {
          flex-basis: 50%;
        }

        .right {
          flex-basis: 50%;
        }
      }

      .items {
        flex-basis: 70%;
        border-radius: 8px;
        padding: 10px;
        margin: 0px 30px;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }

    .bottom {
      flex-basis: 10%;
      padding: 10px 30px 30px 30px;
      display: flex;
      justify-content: space-evenly;

      .repeat-btn {
        //border: 2px solid rgb(154, 218, 255);
        //background-color: rgb(126, 208, 255);
        border: 2px solid rgb(100, 100, 100);
        background-color: rgb(97, 97, 97);
        //color: #000;
        transition: 0.4s;

        &:hover {
          transition: 0.4s;
          //background-color: rgb(181, 227, 253);
          background-color: rgb(126, 126, 126);
        }
      }
    }
    /*
    p {
      text-align: center;
    }
*/
    button {
      cursor: pointer;
      align-self: center;
      min-width: 120px;
      transition: 0.4s;

      &:hover {
        transition: 0.4s;
        background-color: rgb(75, 75, 75);
      }
    }
  }
}
</style>
